import React from 'react';
import RenderItem from './RenderItem'
import CustomerPage from './CustomerPage';
import ExportButton from '../ExportButton';
import { isMainAdmin } from '../../utils/isMainAdmin';
import { baseURL } from '../../api/baseURL';
import axios from 'axios';
import { connect } from 'react-redux';
import Loader from '../../Loader';
import Modal from '../../Modal';
import { MDBBtn, MDBInput, MDBPagination, MDBPaginationItem, MDBPaginationLink } from 'mdb-react-ui-kit';
import Pagination from '../Pagination';
import debounce from 'debounce';
import AdminShell from '../layout/AdminShell';
import { countPillStyle, toolbarRowStyle, searchBoxWrapperStyle, thStyle } from '../layout/listUi';

type State = {
    requested: boolean,
    err: boolean,
    customersList: any,
    searchedList: any,
    photoOpen: boolean,
    modalOpen: any
    currentPage: number
};

class CustomerList extends React.Component<{ history: any, token: string, role?: string }> {

    state: State = {
        requested: false,
        err: false,
        customersList: null,
        searchedList: null,
        photoOpen: false,
        modalOpen: false,
        currentPage: 1,
    }

    componentDidMount(): void {
        if (!this.props.token) {
            window.location.pathname = "/";
        }
        else {
            this.getCustomerList(parseInt(window.location.search.split("?page=")[1]) ? parseInt(window.location.search.split("?page=")[1]) : 1);
        }
    }

    getCustomerList = (pageNumber: number) => {
        if (!this.state.requested) {
            this.setState({ err: false, requested: true });
            axios.get(`${baseURL}/customers?page=${pageNumber}&limit=10`,
                {
                    headers: { Authorization: `Bearer ${this.props.token}` }
                })
                .then((response: any) => {
                    //console.log(response);
                    if (response?.data?.message === "success") {
                        this.setState({ customersList: response?.data, requested: false, err: false, currentPage: pageNumber });
                    }
                    else {
                        this.setState({ err: true, requested: false });
                    }
                })
                .catch((error: any) => {
                    //console.log(error);
                    this.setState({ err: true, requested: false });
                })
        }
    }

    toggleOpen = (customerData?: any) => {
        if (this.state.modalOpen) {
            this.setState({ modalOpen: false });
        }
        else {
            this.setState({ modalOpen: customerData || true });
        }
    }

    toggleModal = () => {
        if (this.state.err) {
            this.setState({ err: false });
        }
    }

    onPageChange = (pageNumber: number) => {
        this.getCustomerList(pageNumber);
    }

    updateBlockStatus = (userId: string) => {
        if (userId && !this.state.requested) {
            this.setState({ err: false, requested: true });
            axios.post(`${baseURL}/update-block-status`,
                {
                    userId
                },
                {
                    headers: { Authorization: `Bearer ${this.props.token}` }
                })
                .then((response: any) => {
                    //console.log(response);
                    if (response?.data?.message === "success") {
                        for (let i = 0; i < this.state.customersList.users.length; i++) {
                            if (this.state.customersList.users[i]?._id === userId) {
                                let temp = this.state.customersList;
                                temp.users[i].is_blocked = !temp.users[i].is_blocked;
                                this.setState({ requested: false, err: false, customersList: temp });
                                break;
                            }
                        }
                    }
                    else {
                        this.setState({ err: true, requested: false });
                    }
                })
                .catch((error: any) => {
                    //console.log(error);
                    this.setState({ err: true, requested: false });
                })
        }
    }

    getSearchList = (searchText: string) => {
        if (!this.state.requested) {
            this.setState({ err: false, requested: true });
            axios.get(`${baseURL}/customers?search=${searchText}&limit=10`,
                {
                    headers: { Authorization: `Bearer ${this.props.token}` }
                })
                .then((response: any) => {
                    //console.log(response);
                    if (response?.data?.message === "success") {
                        this.setState({ searchedList: response?.data, requested: false, err: false });
                    }
                    else {
                        this.setState({ err: true, requested: false });
                    }
                })
                .catch((error: any) => {
                    //console.log(error);
                    this.setState({ err: true, requested: false });
                })
        }
    }

    onSearch = debounce((searchText: string) => {
        if (searchText.length > 2) {
            this.getSearchList(searchText);
        }
    }, 100);

    onClickClear = () => {
        let searchInputEl: any = document.getElementById("search_input");
        if (searchInputEl?.value) {
            searchInputEl.value = "";
        }

        if (this.state.searchedList) {
            //console.log("cleared")
            this.setState({ searchedList: null });
        }
    }

    render() {
        return (
            <AdminShell activePage="customers" title="Customers" subtitle="Accounts, bookings, and spend" topbarActions={<ExportButton endpoint="/export/customers" />}>
                <Modal open={this.state.err} hideSec primaryText="Okay" title='Update' onConfirm={this.toggleModal} toggleOpen={this.toggleModal} content={<h6>Something went wrong, please try again later</h6>} />
                {this.state.requested ? <Loader /> : null}
                            <div className="row ">
                                <div className="col-12 grid-margin">
                                    <div className="card">
                                        <div className="card-body">
                                            <h4 className="card-title">
                                                Customers
                                                {this.state.customersList?.total ? <span style={countPillStyle}>{this.state.customersList.total}</span> : null}
                                            </h4>
                                            <div style={toolbarRowStyle}>
                                                <div style={searchBoxWrapperStyle}>
                                                    <MDBInput
                                                        onChange={(e) => {
                                                            this.onSearch(e.target.value)
                                                        }}
                                                        contrast label="Search by Name / Email" id="search_input" type="text" style={{ border: 'none' }} />
                                                </div>
                                                <MDBBtn onClick={() => { this.onClickClear() }} style={{ width: '200px' }} color='secondary' rippleColor='light'>Clear</MDBBtn>
                                            </div>
                                            <div className="table-responsive">
                                                {(this.state.searchedList?.users?.length || this.state.customersList?.users?.length) ? < table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th style={thStyle}> Customer Name </th>
                                                            <th style={thStyle}> Email </th>
                                                            <th style={thStyle}> Contact </th>
                                                            <th style={thStyle}> Bookings </th>
                                                            <th style={thStyle}> Total Spend </th>
                                                            <th style={thStyle}> Action </th>
                                                            <th style={thStyle}> Last Used Address </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.searchedList?.users?.length ?
                                                            this.state.searchedList?.users.map((item: any) => {
                                                                return <RenderItem key={item?._id} item={item} toggleOpen={this.toggleOpen} updateBlockStatus={this.updateBlockStatus} isMainAdmin={isMainAdmin(this.props.role)} />;
                                                            }) : this.state.customersList?.users?.length ?
                                                                this.state.customersList?.users.map((item: any) => {
                                                                    return <RenderItem key={item?._id} item={item} toggleOpen={this.toggleOpen} updateBlockStatus={this.updateBlockStatus} isMainAdmin={isMainAdmin(this.props.role)} />;
                                                                })
                                                                : null}
                                                    </tbody>
                                                </table> : <div style={{ display: 'flex', justifyContent: 'center', padding: 15, paddingTop: 30 }}>
                                                    <div className="badge badge-outline-secondary" style={{ fontSize: 16 }}>No Data</div>
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {((this.state.customersList?.total / 10) > 1) && !this.state.searchedList?.length ? <Pagination onPageChange={this.onPageChange} currentPage={this.state.currentPage} totalPages={(this.state.customersList?.total / 10) < 1 ? (this.state.customersList?.total / 10) : Math.ceil(this.state.customersList?.total / 10)} maxVisible={5} /> : null}
                <CustomerPage open={this.state.modalOpen} toggleOpen={this.toggleOpen} token={this.props.token} />
            </AdminShell>
        );
    }
}

const mapDispatchToProps = (dispatch: Function) => {
    return {
        dispatch
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        token: state.auth.token,
        role: state.auth.role,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerList);
